import { useRef, useEffect, useCallback } from 'react';
import throttle from "lodash/throttle";

/**
 * @source https://stackoverflow.com/questions/54666401/how-to-use-throttle-or-debounce-with-react-hook/62017005#62017005
 */
export default function useThrottle(cb, delay) {
  const options = {
    leading: true,
    trailing: false
  };
  const cbRef = useRef(cb);

  useEffect(() => {
    cbRef.current = cb;
  });

  return useCallback(
    throttle(
      (...args) => cbRef.current(...args), delay, options
    ),
    [delay]
  );
}